<template>
  <div class="bussinessUnit">
    <p class="bussinessUnit_title">业务范围</p>
    <div class="bussinessUnitList">
      <div
        v-for="(item, index) in businessList"
        :key="index"
        class="bussinessUnitListBox"
        :style="{ backgroundImage: `url(${item.icon})` }"
      >
        <h4>{{ item.title }}</h4>
        <p>{{ item.bussinessDet }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "bussinessUnit",
  data() {
    return {
      businessList: [
        {
          icon: require("../../../assets/association/z1.png"),
          title: "行业调研",
          bussinessDet:
            "对行业进行调研，了解当前市场需求和行业趋势，为 企业提供参考意见",
        },
        {
          icon: require("../../../assets/association/z2.png"),
          title: "技术研发",
          bussinessDet:
            "组织技术人员针对行业中存在的难题和问题进行研究和开发，推动行业技术进步",
        },
        {
          icon: require("../../../assets/association/z3.png"),
          title: "标准制定",
          bussinessDet:
            "制定行业标准和规范，建立产品质量监督体系，提高产品质量和市场竞争力",
        },
        {
          icon: require("../../../assets/association/z4.png"),
          title: "交流培训",
          bussinessDet:
            "组织各种形式的培训和交流活动，包括技术论坛、研讨会等，提高行业从业人员的专业技能和知识水平",
        },
      ],
    };
  },
  methods: {
  },
};
</script>
<style scoped lang="less">
.bussinessUnit {
  background: url("../../../assets/association/z5.jpg") no-repeat;
  background-size: 100% 100%;
  padding-bottom: 28px;
  padding-top: 22px;
  .bussinessUnit_title {
    width: 1200px;
    font-size: 24px;
    font-weight: 500;
    // color: #FFFFFF;
    margin: 0 auto;
    margin-bottom: 15px;
  }
  .bussinessUnitList {
    width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 277px 277px 277px 277px;
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    .bussinessUnitListBox {
      position: relative;
      background: #FFFFFF;
      box-shadow: 0px 1px 20px 2px rgba(0,153,153,0.5);
      border-radius: 10px;
      box-sizing: border-box;
      transition: all 0.2s;
      height: 340px;
      width: 280px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      &:hover {
        transform: scale(1.1);
        h4 {
          color: #009999;
        }
      }
      h4 {
        padding: 30px 30px 20px;
        font-size: 20px;
      }
      p {
        padding: 10px 30px;
        padding-top: 0;
        font-size: 14px;
        color: #636366;
        line-height: 24px;
      }
    }
    .bussinessUnitImg {
      position: absolute;
      bottom: 41px;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/association/components/businessUnit.vue